export const ACCOUNT_NUM_MAX_LENGTH = 10;
export const BOND_NUM_LENGTH = 8;
export const ACCOUNT_NAME_BOND_NUMBER_MAX_LENGTH = 50;
